/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as CodeRouteImport } from './routes/$code'
import { Route as ActivateEmailTokenRouteImport } from './routes/activate-email.$token'
import { Route as AuthRegisterRouteImport } from './routes/_auth.register'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth.forgot-password'
import { Route as AppdashboardIndexRouteImport } from './routes/_app/(dashboard)/index'
import { Route as AuthResetPasswordTokenRouteImport } from './routes/_auth.reset-password.$token'
import { Route as AuthRegisterTeamAndClientsRouteImport } from './routes/_auth.register.team-and-clients'
import { Route as AuthRegisterTeamRouteImport } from './routes/_auth.register.team'
import { Route as AuthInviteTokenRouteImport } from './routes/_auth.invite.$token'
import { Route as ApptaxonomyTaxonomyRouteImport } from './routes/_app/(taxonomy)/taxonomy'
import { Route as ApptaxonomyCategoriesRouteImport } from './routes/_app/(taxonomy)/categories'
import { Route as ApponboardingOnboardingRouteImport } from './routes/_app/(onboarding)/onboarding'
import { Route as AppinsightsAdvancedInsightsV2RouteImport } from './routes/_app/(insights)/advanced-insights-v2'
import { Route as AppdiscoveryDiscoveryRouteImport } from './routes/_app/(discovery)/discovery'
import { Route as AppaccountUsersRouteImport } from './routes/_app/(account)/users'
import { Route as AppaccountSettingsRouteImport } from './routes/_app/(account)/settings'
import { Route as AppaccountIntegrationsRouteImport } from './routes/_app/(account)/integrations'
import { Route as AppaccountAccountRouteImport } from './routes/_app/(account)/account'
import { Route as ApppeoplePeopleIndexRouteImport } from './routes/_app/(people)/people.index'
import { Route as ApppeopleCompaniesIndexRouteImport } from './routes/_app/(people)/companies.index'
import { Route as AppaccountSettingsIndexRouteImport } from './routes/_app/(account)/settings.index'
import { Route as ApppeoplePeopleClientIdRouteImport } from './routes/_app/(people)/people.$clientId'
import { Route as ApppeopleCompaniesClientIdRouteImport } from './routes/_app/(people)/companies.$clientId'
import { Route as ApponboardingOnboardingProcessingRouteImport } from './routes/_app/(onboarding)/onboarding.processing'
import { Route as ApponboardingOnboardingActivateRouteImport } from './routes/_app/(onboarding)/onboarding.activate'
import { Route as AppaccountSettingsTabRouteImport } from './routes/_app/(account)/settings.$tab'
import { Route as ApppeoplePeopleCurrentTabClientIdRouteImport } from './routes/_app/(people)/people.$currentTab.$clientId'
import { Route as ApppeopleCompaniesCurrentTabCompanyIdRouteImport } from './routes/_app/(people)/companies.$currentTab.$companyId'
import { Route as ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125RouteImport } from './routes/_app/(taxonomy)/topic.$tab.$topicId.$groupId.{-$subtopicId}'

const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const CodeRoute = CodeRouteImport.update({
  id: '/$code',
  path: '/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateEmailTokenRoute = ActivateEmailTokenRouteImport.update({
  id: '/activate-email/$token',
  path: '/activate-email/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppdashboardIndexRoute = AppdashboardIndexRouteImport.update({
  id: '/(dashboard)/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthResetPasswordTokenRoute = AuthResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterTeamAndClientsRoute =
  AuthRegisterTeamAndClientsRouteImport.update({
    id: '/team-and-clients',
    path: '/team-and-clients',
    getParentRoute: () => AuthRegisterRoute,
  } as any)
const AuthRegisterTeamRoute = AuthRegisterTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthRegisterRoute,
} as any)
const AuthInviteTokenRoute = AuthInviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => AuthRoute,
} as any)
const ApptaxonomyTaxonomyRoute = ApptaxonomyTaxonomyRouteImport.update({
  id: '/(taxonomy)/taxonomy',
  path: '/taxonomy',
  getParentRoute: () => AppRoute,
} as any)
const ApptaxonomyCategoriesRoute = ApptaxonomyCategoriesRouteImport.update({
  id: '/(taxonomy)/categories',
  path: '/categories',
  getParentRoute: () => AppRoute,
} as any)
const ApponboardingOnboardingRoute = ApponboardingOnboardingRouteImport.update({
  id: '/(onboarding)/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppinsightsAdvancedInsightsV2Route =
  AppinsightsAdvancedInsightsV2RouteImport.update({
    id: '/(insights)/advanced-insights-v2',
    path: '/advanced-insights-v2',
    getParentRoute: () => AppRoute,
  } as any)
const AppdiscoveryDiscoveryRoute = AppdiscoveryDiscoveryRouteImport.update({
  id: '/(discovery)/discovery',
  path: '/discovery',
  getParentRoute: () => AppRoute,
} as any)
const AppaccountUsersRoute = AppaccountUsersRouteImport.update({
  id: '/(account)/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppaccountSettingsRoute = AppaccountSettingsRouteImport.update({
  id: '/(account)/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppaccountIntegrationsRoute = AppaccountIntegrationsRouteImport.update({
  id: '/(account)/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppaccountAccountRoute = AppaccountAccountRouteImport.update({
  id: '/(account)/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const ApppeoplePeopleIndexRoute = ApppeoplePeopleIndexRouteImport.update({
  id: '/(people)/people/',
  path: '/people/',
  getParentRoute: () => AppRoute,
} as any)
const ApppeopleCompaniesIndexRoute = ApppeopleCompaniesIndexRouteImport.update({
  id: '/(people)/companies/',
  path: '/companies/',
  getParentRoute: () => AppRoute,
} as any)
const AppaccountSettingsIndexRoute = AppaccountSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppaccountSettingsRoute,
} as any)
const ApppeoplePeopleClientIdRoute = ApppeoplePeopleClientIdRouteImport.update({
  id: '/(people)/people/$clientId',
  path: '/people/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const ApppeopleCompaniesClientIdRoute =
  ApppeopleCompaniesClientIdRouteImport.update({
    id: '/(people)/companies/$clientId',
    path: '/companies/$clientId',
    getParentRoute: () => AppRoute,
  } as any)
const ApponboardingOnboardingProcessingRoute =
  ApponboardingOnboardingProcessingRouteImport.update({
    id: '/processing',
    path: '/processing',
    getParentRoute: () => ApponboardingOnboardingRoute,
  } as any)
const ApponboardingOnboardingActivateRoute =
  ApponboardingOnboardingActivateRouteImport.update({
    id: '/activate',
    path: '/activate',
    getParentRoute: () => ApponboardingOnboardingRoute,
  } as any)
const AppaccountSettingsTabRoute = AppaccountSettingsTabRouteImport.update({
  id: '/$tab',
  path: '/$tab',
  getParentRoute: () => AppaccountSettingsRoute,
} as any)
const ApppeoplePeopleCurrentTabClientIdRoute =
  ApppeoplePeopleCurrentTabClientIdRouteImport.update({
    id: '/(people)/people/$currentTab/$clientId',
    path: '/people/$currentTab/$clientId',
    getParentRoute: () => AppRoute,
  } as any)
const ApppeopleCompaniesCurrentTabCompanyIdRoute =
  ApppeopleCompaniesCurrentTabCompanyIdRouteImport.update({
    id: '/(people)/companies/$currentTab/$companyId',
    path: '/companies/$currentTab/$companyId',
    getParentRoute: () => AppRoute,
  } as any)
const ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125Route =
  ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125RouteImport.update({
    id: '/(taxonomy)/topic/$tab/$topicId/$groupId/{-$subtopicId}',
    path: '/topic/$tab/$topicId/$groupId/{-$subtopicId}',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$code': typeof CodeRoute
  '/': typeof AppdashboardIndexRoute
  '/error': typeof ErrorRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms': typeof TermsRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRouteWithChildren
  '/activate-email/$token': typeof ActivateEmailTokenRoute
  '/account': typeof AppaccountAccountRoute
  '/integrations': typeof AppaccountIntegrationsRoute
  '/settings': typeof AppaccountSettingsRouteWithChildren
  '/users': typeof AppaccountUsersRoute
  '/discovery': typeof AppdiscoveryDiscoveryRoute
  '/advanced-insights-v2': typeof AppinsightsAdvancedInsightsV2Route
  '/onboarding': typeof ApponboardingOnboardingRouteWithChildren
  '/categories': typeof ApptaxonomyCategoriesRoute
  '/taxonomy': typeof ApptaxonomyTaxonomyRoute
  '/invite/$token': typeof AuthInviteTokenRoute
  '/register/team': typeof AuthRegisterTeamRoute
  '/register/team-and-clients': typeof AuthRegisterTeamAndClientsRoute
  '/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/settings/$tab': typeof AppaccountSettingsTabRoute
  '/onboarding/activate': typeof ApponboardingOnboardingActivateRoute
  '/onboarding/processing': typeof ApponboardingOnboardingProcessingRoute
  '/companies/$clientId': typeof ApppeopleCompaniesClientIdRoute
  '/people/$clientId': typeof ApppeoplePeopleClientIdRoute
  '/settings/': typeof AppaccountSettingsIndexRoute
  '/companies/': typeof ApppeopleCompaniesIndexRoute
  '/people/': typeof ApppeoplePeopleIndexRoute
  '/companies/$currentTab/$companyId': typeof ApppeopleCompaniesCurrentTabCompanyIdRoute
  '/people/$currentTab/$clientId': typeof ApppeoplePeopleCurrentTabClientIdRoute
  '/topic/$tab/$topicId/$groupId/{-$subtopicId}': typeof ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125Route
}
export interface FileRoutesByTo {
  '/$code': typeof CodeRoute
  '/': typeof AppdashboardIndexRoute
  '/error': typeof ErrorRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms': typeof TermsRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRouteWithChildren
  '/activate-email/$token': typeof ActivateEmailTokenRoute
  '/account': typeof AppaccountAccountRoute
  '/integrations': typeof AppaccountIntegrationsRoute
  '/users': typeof AppaccountUsersRoute
  '/discovery': typeof AppdiscoveryDiscoveryRoute
  '/advanced-insights-v2': typeof AppinsightsAdvancedInsightsV2Route
  '/onboarding': typeof ApponboardingOnboardingRouteWithChildren
  '/categories': typeof ApptaxonomyCategoriesRoute
  '/taxonomy': typeof ApptaxonomyTaxonomyRoute
  '/invite/$token': typeof AuthInviteTokenRoute
  '/register/team': typeof AuthRegisterTeamRoute
  '/register/team-and-clients': typeof AuthRegisterTeamAndClientsRoute
  '/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/settings/$tab': typeof AppaccountSettingsTabRoute
  '/onboarding/activate': typeof ApponboardingOnboardingActivateRoute
  '/onboarding/processing': typeof ApponboardingOnboardingProcessingRoute
  '/companies/$clientId': typeof ApppeopleCompaniesClientIdRoute
  '/people/$clientId': typeof ApppeoplePeopleClientIdRoute
  '/settings': typeof AppaccountSettingsIndexRoute
  '/companies': typeof ApppeopleCompaniesIndexRoute
  '/people': typeof ApppeoplePeopleIndexRoute
  '/companies/$currentTab/$companyId': typeof ApppeopleCompaniesCurrentTabCompanyIdRoute
  '/people/$currentTab/$clientId': typeof ApppeoplePeopleCurrentTabClientIdRoute
  '/topic/$tab/$topicId/$groupId/{-$subtopicId}': typeof ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125Route
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$code': typeof CodeRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/error': typeof ErrorRoute
  '/privacy': typeof PrivacyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms': typeof TermsRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRouteWithChildren
  '/activate-email/$token': typeof ActivateEmailTokenRoute
  '/_app/(account)/account': typeof AppaccountAccountRoute
  '/_app/(account)/integrations': typeof AppaccountIntegrationsRoute
  '/_app/(account)/settings': typeof AppaccountSettingsRouteWithChildren
  '/_app/(account)/users': typeof AppaccountUsersRoute
  '/_app/(discovery)/discovery': typeof AppdiscoveryDiscoveryRoute
  '/_app/(insights)/advanced-insights-v2': typeof AppinsightsAdvancedInsightsV2Route
  '/_app/(onboarding)/onboarding': typeof ApponboardingOnboardingRouteWithChildren
  '/_app/(taxonomy)/categories': typeof ApptaxonomyCategoriesRoute
  '/_app/(taxonomy)/taxonomy': typeof ApptaxonomyTaxonomyRoute
  '/_auth/invite/$token': typeof AuthInviteTokenRoute
  '/_auth/register/team': typeof AuthRegisterTeamRoute
  '/_auth/register/team-and-clients': typeof AuthRegisterTeamAndClientsRoute
  '/_auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/_app/(dashboard)/': typeof AppdashboardIndexRoute
  '/_app/(account)/settings/$tab': typeof AppaccountSettingsTabRoute
  '/_app/(onboarding)/onboarding/activate': typeof ApponboardingOnboardingActivateRoute
  '/_app/(onboarding)/onboarding/processing': typeof ApponboardingOnboardingProcessingRoute
  '/_app/(people)/companies/$clientId': typeof ApppeopleCompaniesClientIdRoute
  '/_app/(people)/people/$clientId': typeof ApppeoplePeopleClientIdRoute
  '/_app/(account)/settings/': typeof AppaccountSettingsIndexRoute
  '/_app/(people)/companies/': typeof ApppeopleCompaniesIndexRoute
  '/_app/(people)/people/': typeof ApppeoplePeopleIndexRoute
  '/_app/(people)/companies/$currentTab/$companyId': typeof ApppeopleCompaniesCurrentTabCompanyIdRoute
  '/_app/(people)/people/$currentTab/$clientId': typeof ApppeoplePeopleCurrentTabClientIdRoute
  '/_app/(taxonomy)/topic/$tab/$topicId/$groupId/{-$subtopicId}': typeof ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125Route
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$code'
    | '/'
    | '/error'
    | '/privacy'
    | '/privacy-policy'
    | '/terms'
    | '/terms-of-service'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/activate-email/$token'
    | '/account'
    | '/integrations'
    | '/settings'
    | '/users'
    | '/discovery'
    | '/advanced-insights-v2'
    | '/onboarding'
    | '/categories'
    | '/taxonomy'
    | '/invite/$token'
    | '/register/team'
    | '/register/team-and-clients'
    | '/reset-password/$token'
    | '/settings/$tab'
    | '/onboarding/activate'
    | '/onboarding/processing'
    | '/companies/$clientId'
    | '/people/$clientId'
    | '/settings/'
    | '/companies/'
    | '/people/'
    | '/companies/$currentTab/$companyId'
    | '/people/$currentTab/$clientId'
    | '/topic/$tab/$topicId/$groupId/{-$subtopicId}'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$code'
    | '/'
    | '/error'
    | '/privacy'
    | '/privacy-policy'
    | '/terms'
    | '/terms-of-service'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/activate-email/$token'
    | '/account'
    | '/integrations'
    | '/users'
    | '/discovery'
    | '/advanced-insights-v2'
    | '/onboarding'
    | '/categories'
    | '/taxonomy'
    | '/invite/$token'
    | '/register/team'
    | '/register/team-and-clients'
    | '/reset-password/$token'
    | '/settings/$tab'
    | '/onboarding/activate'
    | '/onboarding/processing'
    | '/companies/$clientId'
    | '/people/$clientId'
    | '/settings'
    | '/companies'
    | '/people'
    | '/companies/$currentTab/$companyId'
    | '/people/$currentTab/$clientId'
    | '/topic/$tab/$topicId/$groupId/{-$subtopicId}'
  id:
    | '__root__'
    | '/$code'
    | '/_app'
    | '/_auth'
    | '/error'
    | '/privacy'
    | '/privacy-policy'
    | '/terms'
    | '/terms-of-service'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/register'
    | '/activate-email/$token'
    | '/_app/(account)/account'
    | '/_app/(account)/integrations'
    | '/_app/(account)/settings'
    | '/_app/(account)/users'
    | '/_app/(discovery)/discovery'
    | '/_app/(insights)/advanced-insights-v2'
    | '/_app/(onboarding)/onboarding'
    | '/_app/(taxonomy)/categories'
    | '/_app/(taxonomy)/taxonomy'
    | '/_auth/invite/$token'
    | '/_auth/register/team'
    | '/_auth/register/team-and-clients'
    | '/_auth/reset-password/$token'
    | '/_app/(dashboard)/'
    | '/_app/(account)/settings/$tab'
    | '/_app/(onboarding)/onboarding/activate'
    | '/_app/(onboarding)/onboarding/processing'
    | '/_app/(people)/companies/$clientId'
    | '/_app/(people)/people/$clientId'
    | '/_app/(account)/settings/'
    | '/_app/(people)/companies/'
    | '/_app/(people)/people/'
    | '/_app/(people)/companies/$currentTab/$companyId'
    | '/_app/(people)/people/$currentTab/$clientId'
    | '/_app/(taxonomy)/topic/$tab/$topicId/$groupId/{-$subtopicId}'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CodeRoute: typeof CodeRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  PrivacyRoute: typeof PrivacyRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsRoute: typeof TermsRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  ActivateEmailTokenRoute: typeof ActivateEmailTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$code': {
      id: '/$code'
      path: '/$code'
      fullPath: '/$code'
      preLoaderRoute: typeof CodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate-email/$token': {
      id: '/activate-email/$token'
      path: '/activate-email/$token'
      fullPath: '/activate-email/$token'
      preLoaderRoute: typeof ActivateEmailTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/(dashboard)/': {
      id: '/_app/(dashboard)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppdashboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/reset-password/$token': {
      id: '/_auth/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof AuthResetPasswordTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register/team-and-clients': {
      id: '/_auth/register/team-and-clients'
      path: '/team-and-clients'
      fullPath: '/register/team-and-clients'
      preLoaderRoute: typeof AuthRegisterTeamAndClientsRouteImport
      parentRoute: typeof AuthRegisterRoute
    }
    '/_auth/register/team': {
      id: '/_auth/register/team'
      path: '/team'
      fullPath: '/register/team'
      preLoaderRoute: typeof AuthRegisterTeamRouteImport
      parentRoute: typeof AuthRegisterRoute
    }
    '/_auth/invite/$token': {
      id: '/_auth/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof AuthInviteTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/(taxonomy)/taxonomy': {
      id: '/_app/(taxonomy)/taxonomy'
      path: '/taxonomy'
      fullPath: '/taxonomy'
      preLoaderRoute: typeof ApptaxonomyTaxonomyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(taxonomy)/categories': {
      id: '/_app/(taxonomy)/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof ApptaxonomyCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(onboarding)/onboarding': {
      id: '/_app/(onboarding)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof ApponboardingOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(insights)/advanced-insights-v2': {
      id: '/_app/(insights)/advanced-insights-v2'
      path: '/advanced-insights-v2'
      fullPath: '/advanced-insights-v2'
      preLoaderRoute: typeof AppinsightsAdvancedInsightsV2RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(discovery)/discovery': {
      id: '/_app/(discovery)/discovery'
      path: '/discovery'
      fullPath: '/discovery'
      preLoaderRoute: typeof AppdiscoveryDiscoveryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(account)/users': {
      id: '/_app/(account)/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppaccountUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(account)/settings': {
      id: '/_app/(account)/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppaccountSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(account)/integrations': {
      id: '/_app/(account)/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppaccountIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(account)/account': {
      id: '/_app/(account)/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppaccountAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(people)/people/': {
      id: '/_app/(people)/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof ApppeoplePeopleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(people)/companies/': {
      id: '/_app/(people)/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof ApppeopleCompaniesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(account)/settings/': {
      id: '/_app/(account)/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppaccountSettingsIndexRouteImport
      parentRoute: typeof AppaccountSettingsRoute
    }
    '/_app/(people)/people/$clientId': {
      id: '/_app/(people)/people/$clientId'
      path: '/people/$clientId'
      fullPath: '/people/$clientId'
      preLoaderRoute: typeof ApppeoplePeopleClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(people)/companies/$clientId': {
      id: '/_app/(people)/companies/$clientId'
      path: '/companies/$clientId'
      fullPath: '/companies/$clientId'
      preLoaderRoute: typeof ApppeopleCompaniesClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(onboarding)/onboarding/processing': {
      id: '/_app/(onboarding)/onboarding/processing'
      path: '/processing'
      fullPath: '/onboarding/processing'
      preLoaderRoute: typeof ApponboardingOnboardingProcessingRouteImport
      parentRoute: typeof ApponboardingOnboardingRoute
    }
    '/_app/(onboarding)/onboarding/activate': {
      id: '/_app/(onboarding)/onboarding/activate'
      path: '/activate'
      fullPath: '/onboarding/activate'
      preLoaderRoute: typeof ApponboardingOnboardingActivateRouteImport
      parentRoute: typeof ApponboardingOnboardingRoute
    }
    '/_app/(account)/settings/$tab': {
      id: '/_app/(account)/settings/$tab'
      path: '/$tab'
      fullPath: '/settings/$tab'
      preLoaderRoute: typeof AppaccountSettingsTabRouteImport
      parentRoute: typeof AppaccountSettingsRoute
    }
    '/_app/(people)/people/$currentTab/$clientId': {
      id: '/_app/(people)/people/$currentTab/$clientId'
      path: '/people/$currentTab/$clientId'
      fullPath: '/people/$currentTab/$clientId'
      preLoaderRoute: typeof ApppeoplePeopleCurrentTabClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(people)/companies/$currentTab/$companyId': {
      id: '/_app/(people)/companies/$currentTab/$companyId'
      path: '/companies/$currentTab/$companyId'
      fullPath: '/companies/$currentTab/$companyId'
      preLoaderRoute: typeof ApppeopleCompaniesCurrentTabCompanyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/(taxonomy)/topic/$tab/$topicId/$groupId/{-$subtopicId}': {
      id: '/_app/(taxonomy)/topic/$tab/$topicId/$groupId/{-$subtopicId}'
      path: '/topic/$tab/$topicId/$groupId/{-$subtopicId}'
      fullPath: '/topic/$tab/$topicId/$groupId/{-$subtopicId}'
      preLoaderRoute: typeof ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125RouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppaccountSettingsRouteChildren {
  AppaccountSettingsTabRoute: typeof AppaccountSettingsTabRoute
  AppaccountSettingsIndexRoute: typeof AppaccountSettingsIndexRoute
}

const AppaccountSettingsRouteChildren: AppaccountSettingsRouteChildren = {
  AppaccountSettingsTabRoute: AppaccountSettingsTabRoute,
  AppaccountSettingsIndexRoute: AppaccountSettingsIndexRoute,
}

const AppaccountSettingsRouteWithChildren =
  AppaccountSettingsRoute._addFileChildren(AppaccountSettingsRouteChildren)

interface ApponboardingOnboardingRouteChildren {
  ApponboardingOnboardingActivateRoute: typeof ApponboardingOnboardingActivateRoute
  ApponboardingOnboardingProcessingRoute: typeof ApponboardingOnboardingProcessingRoute
}

const ApponboardingOnboardingRouteChildren: ApponboardingOnboardingRouteChildren =
  {
    ApponboardingOnboardingActivateRoute: ApponboardingOnboardingActivateRoute,
    ApponboardingOnboardingProcessingRoute:
      ApponboardingOnboardingProcessingRoute,
  }

const ApponboardingOnboardingRouteWithChildren =
  ApponboardingOnboardingRoute._addFileChildren(
    ApponboardingOnboardingRouteChildren,
  )

interface AppRouteChildren {
  AppaccountAccountRoute: typeof AppaccountAccountRoute
  AppaccountIntegrationsRoute: typeof AppaccountIntegrationsRoute
  AppaccountSettingsRoute: typeof AppaccountSettingsRouteWithChildren
  AppaccountUsersRoute: typeof AppaccountUsersRoute
  AppdiscoveryDiscoveryRoute: typeof AppdiscoveryDiscoveryRoute
  AppinsightsAdvancedInsightsV2Route: typeof AppinsightsAdvancedInsightsV2Route
  ApponboardingOnboardingRoute: typeof ApponboardingOnboardingRouteWithChildren
  ApptaxonomyCategoriesRoute: typeof ApptaxonomyCategoriesRoute
  ApptaxonomyTaxonomyRoute: typeof ApptaxonomyTaxonomyRoute
  AppdashboardIndexRoute: typeof AppdashboardIndexRoute
  ApppeopleCompaniesClientIdRoute: typeof ApppeopleCompaniesClientIdRoute
  ApppeoplePeopleClientIdRoute: typeof ApppeoplePeopleClientIdRoute
  ApppeopleCompaniesIndexRoute: typeof ApppeopleCompaniesIndexRoute
  ApppeoplePeopleIndexRoute: typeof ApppeoplePeopleIndexRoute
  ApppeopleCompaniesCurrentTabCompanyIdRoute: typeof ApppeopleCompaniesCurrentTabCompanyIdRoute
  ApppeoplePeopleCurrentTabClientIdRoute: typeof ApppeoplePeopleCurrentTabClientIdRoute
  ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125Route: typeof ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125Route
}

const AppRouteChildren: AppRouteChildren = {
  AppaccountAccountRoute: AppaccountAccountRoute,
  AppaccountIntegrationsRoute: AppaccountIntegrationsRoute,
  AppaccountSettingsRoute: AppaccountSettingsRouteWithChildren,
  AppaccountUsersRoute: AppaccountUsersRoute,
  AppdiscoveryDiscoveryRoute: AppdiscoveryDiscoveryRoute,
  AppinsightsAdvancedInsightsV2Route: AppinsightsAdvancedInsightsV2Route,
  ApponboardingOnboardingRoute: ApponboardingOnboardingRouteWithChildren,
  ApptaxonomyCategoriesRoute: ApptaxonomyCategoriesRoute,
  ApptaxonomyTaxonomyRoute: ApptaxonomyTaxonomyRoute,
  AppdashboardIndexRoute: AppdashboardIndexRoute,
  ApppeopleCompaniesClientIdRoute: ApppeopleCompaniesClientIdRoute,
  ApppeoplePeopleClientIdRoute: ApppeoplePeopleClientIdRoute,
  ApppeopleCompaniesIndexRoute: ApppeopleCompaniesIndexRoute,
  ApppeoplePeopleIndexRoute: ApppeoplePeopleIndexRoute,
  ApppeopleCompaniesCurrentTabCompanyIdRoute:
    ApppeopleCompaniesCurrentTabCompanyIdRoute,
  ApppeoplePeopleCurrentTabClientIdRoute:
    ApppeoplePeopleCurrentTabClientIdRoute,
  ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125Route:
    ApptaxonomyTopicTabTopicIdGroupIdChar123SubtopicIdChar125Route,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRegisterRouteChildren {
  AuthRegisterTeamRoute: typeof AuthRegisterTeamRoute
  AuthRegisterTeamAndClientsRoute: typeof AuthRegisterTeamAndClientsRoute
}

const AuthRegisterRouteChildren: AuthRegisterRouteChildren = {
  AuthRegisterTeamRoute: AuthRegisterTeamRoute,
  AuthRegisterTeamAndClientsRoute: AuthRegisterTeamAndClientsRoute,
}

const AuthRegisterRouteWithChildren = AuthRegisterRoute._addFileChildren(
  AuthRegisterRouteChildren,
)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRouteWithChildren
  AuthInviteTokenRoute: typeof AuthInviteTokenRoute
  AuthResetPasswordTokenRoute: typeof AuthResetPasswordTokenRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRouteWithChildren,
  AuthInviteTokenRoute: AuthInviteTokenRoute,
  AuthResetPasswordTokenRoute: AuthResetPasswordTokenRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  CodeRoute: CodeRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ErrorRoute: ErrorRoute,
  PrivacyRoute: PrivacyRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsRoute: TermsRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  ActivateEmailTokenRoute: ActivateEmailTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
